import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    fetchRestrictedAccessStatus,
    verifyRestrictedAccessPassword,
} from "../../api/restrictedAccess";

export const RESTRICTED_ACCESS_STORAGE_KEY = "restrictedAccessUnlocked";

export const loadRestrictedAccessStatus = createAsyncThunk(
    "restrictedAccess/loadStatus",
    async (_, { rejectWithValue }) => {
        try {
            return await fetchRestrictedAccessStatus();
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    },
);

export const unlockRestrictedAccess = createAsyncThunk(
    "restrictedAccess/unlock",
    async (password, { rejectWithValue }) => {
        try {
            return await verifyRestrictedAccessPassword(password);
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    },
);

const restrictedAccessSlice = createSlice({
    name: "restrictedAccess",
    initialState: {
        unlocked:
            sessionStorage.getItem(RESTRICTED_ACCESS_STORAGE_KEY) === "true",
        enabled: true,
        isStatusLoaded: false,
        isVerifying: false,
        errorMessage: "",
    },
    reducers: {
        lockRestrictedAccess: (state) => {
            state.unlocked = false;
            sessionStorage.removeItem(RESTRICTED_ACCESS_STORAGE_KEY);
            state.isStatusLoaded = false;
            state.errorMessage = "";
        },
        clearRestrictedAccessError: (state) => {
            state.errorMessage = "";
        },
    },
    extraReducers: (builder) => {
        builder.addCase(loadRestrictedAccessStatus.fulfilled, (state, action) => {
            state.enabled = action.payload?.enabled !== false;
            state.isStatusLoaded = true;
            if (!state.enabled) {
                state.unlocked = true;
            }
        });
        builder.addCase(loadRestrictedAccessStatus.rejected, (state) => {
            state.enabled = true;
            state.isStatusLoaded = true;
        });
        builder.addCase(unlockRestrictedAccess.pending, (state) => {
            state.isVerifying = true;
            state.errorMessage = "";
        });
        builder.addCase(unlockRestrictedAccess.fulfilled, (state) => {
            state.isVerifying = false;
            state.unlocked = true;
            state.errorMessage = "";
            sessionStorage.setItem(RESTRICTED_ACCESS_STORAGE_KEY, "true");
        });
        builder.addCase(unlockRestrictedAccess.rejected, (state, action) => {
            state.isVerifying = false;
            state.unlocked = false;
            sessionStorage.removeItem(RESTRICTED_ACCESS_STORAGE_KEY);
            state.errorMessage =
                action.payload?.message || "Incorrect password";
        });
    },
});

export const { lockRestrictedAccess, clearRestrictedAccessError } =
    restrictedAccessSlice.actions;

export default restrictedAccessSlice.reducer;
